<template>
  <NDialogProvider>
    <LicenseWarningBanner v-if="isAuthenticated" />
    <router-view />
  </NDialogProvider>
</template>

<script setup>
import { NDialogProvider } from 'naive-ui'
import LicenseWarningBanner from '@shared/components/LicenseWarningBanner.vue'
import { useAuth } from '@shared/composables/useAuth.js'

const { isAuthenticated } = useAuth()
</script>
